import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b38f5ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "state" }
const _hoisted_2 = { class: "status-card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "仅授权本次正式版更新，24小时有效。本机执行端只领取一次；确认版本号更新后自动关闭。执行失败须取消并重新验证才能重试。", -1))
const _hoisted_4 = { class: "target-version" }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = {
  key: 3,
  class: "simulation"
}
const _hoisted_7 = { key: 0 }

import { computed, onBeforeUnmount, ref, watch } from 'vue'
import PlatformOperationVerification from './PlatformOperationVerification.vue'
import { message } from 'ant-design-vue'
import request from '@/utils/request'
import store from '@/store'
import { isPlatformSuperAdministrator } from '@/utils/platformAdministration'
// 2026-10-30：接入服务端真实验证码和一次性授权，移除模拟验证码与模拟版本更新。

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductionUpdateControl',
  setup(__props, { expose: __expose }) {

const allowed = computed(() => isPlatformSuperAdministrator(store.getters.userInfo))
const receiverId=ref('super')
const visible=ref(false), enabled=ref(false), verifying=ref(false), sent=ref(false), code=ref(''), completed=ref(false)
function openPanel(){if(allowed.value){receiverId.value='super';visible.value=true}}
__expose({openPanel})
const targetVersion=ref(''),targetLoading=ref(false)
async function refreshTarget(){const current=generation;targetLoading.value=true;targetVersion.value='';try{const response=await api('/target');if(current===generation)targetVersion.value=response.data?.version || ''}catch{if(current===generation)targetVersion.value=''}finally{if(current===generation)targetLoading.value=false}}
const completedVersion=ref(''),completedAt=ref(0),notificationStatus=ref<Record<string,string>>({})
const completionText=computed(()=>completedVersion.value || version.value ? '正式版更新已完成，已更新到 V'+(completedVersion.value || version.value)+'，已自动关闭' : '更新完成，已自动关闭')
const completedTime=computed(()=>completedAt.value>0 ? new Date(completedAt.value*1000).toLocaleString('zh-CN',{timeZone:'Asia/Shanghai',hour12:false}) : '')
const notificationChannels=[{key:'inbox',label:'站内通知'},{key:'sms',label:'短信通知'},{key:'wechat',label:'公众号通知'}]
function notificationText(value:string){const text:Record<string,string>={SENT:'已发送',ACCEPTED:'服务商已受理',PENDING:'待发送',CHECKING:'处理中',SENDING:'发送中',RETRY:'等待重试',WAIT_CONFIG:'待配置独立通知模板',WAIT_BINDING:'待申请人绑定并关注公众号',WAIT_PHONE:'待申请人完善手机号',WAIT_ENABLED:'当前环境禁止外部发送',UNKNOWN:'结果待核对，不自动重发',FAILED:'发送失败',SKIPPED:'申请人账号已不可用'};return text[value] || '暂无记录（状态保留7天）'}
const version=ref(''), baseline=ref(''),status=ref(''),busy=ref(false),cooldown=ref(0)
const statusText=computed(()=>status.value==='claimed'?'执行端已领取，等待正式版本更新':enabled.value?'等待本机部署执行端更新':completed.value?completionText.value:'自动更新已关闭')
let generation=0,ticks=0
function apply(data:{enabled?:boolean;version?:string;baseline?:string;status?:string;completedVersion?:string;completedAt?:number;notificationStatus?:Record<string,string>}){enabled.value=!!data.enabled;version.value=data.version||'';baseline.value=data.baseline||'';status.value=data.status||'';completed.value=data.status==='completed';completedVersion.value=data.completedVersion || '';completedAt.value=Number(data.completedAt) || 0;notificationStatus.value=data.notificationStatus || {}}
async function api(action='',data={}){return request({url:`system/productionUpdate${action}`,method:action && action!=='/target'?'POST':'GET',data})}
async function refresh(){const current=generation;const response=await api();if(current===generation)apply(response.data||{})}
async function mutate(action:string,data={}){if(busy.value)return;busy.value=true;const current=generation;try{const response=await api(action,data);if(current!==generation)return;if(action==='/code'){sent.value=true;cooldown.value=60;message.success('验证码已发送')}else{apply(response.data||{});verifying.value=false;code.value=''}}catch(error){message.error(error instanceof Error?error.message:'更新授权操作失败，请重试')}finally{busy.value=false}}
async function sendCode(){await mutate('/code',{receiverId:receiverId.value})}
async function cancel(){await mutate('/cancel')}
async function requestToggle(value:boolean) {
  if (!allowed.value) return
  if (!value) { await cancel(); return }
  code.value=''; sent.value=false; verifying.value=true
}
async function confirm() {
  if (!allowed.value || !sent.value || !/^\d{6}$/.test(code.value)) return
  await mutate('/enable',{code:code.value,receiverId:receiverId.value})
}
watch(visible,value=>{if(value){refresh().catch(()=>message.error('更新授权读取失败'));void refreshTarget()}})
const timer=setInterval(()=>{if(cooldown.value>0)cooldown.value--;if(++ticks%10===0&&allowed.value)refresh().catch(()=>undefined)},1000)
onBeforeUnmount(()=>clearInterval(timer))
watch(() => [store.getters.token,store.getters.userInfo?.id,store.getters.userInfo?.orgId].join(':'), () => {generation++;completedVersion.value='';completedAt.value=0;notificationStatus.value={};targetVersion.value='';targetLoading.value=false;visible.value=false;enabled.value=false;verifying.value=false;sent.value=false;code.value='';cooldown.value=0})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (allowed.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["production-update-control", { 'custom-trigger': _ctx.$slots.default }])
      }, [
        _renderSlot(_ctx.$slots, "default", {
          openPanel: openPanel,
          enabled: enabled.value
        }, () => [
          _createVNode(_component_a_button, {
            size: "small",
            type: enabled.value ? 'primary' : 'default',
            onClick: openPanel
          }, {
            default: _withCtx(() => [
              _createTextVNode("自动更新正式版 "),
              _createElementVNode("span", _hoisted_1, _toDisplayString(enabled.value ? '已开启' : '已关闭'), 1)
            ]),
            _: 1
          }, 8, ["type"])
        ]),
        _createVNode(_component_a_modal, {
          visible: visible.value,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event)),
          title: "自动更新正式版",
          footer: null,
          width: 540
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_alert, {
              type: completed.value ? 'success' : 'info',
              "show-icon": "",
              message: statusText.value
            }, null, 8, ["type", "message"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, _toDisplayString(enabled.value ? '等待部署执行端更新' : completed.value ? completionText.value : '自动更新已关闭'), 1),
                _createVNode(_component_a_switch, {
                  checked: enabled.value,
                  "checked-children": "开启",
                  "un-checked-children": "关闭",
                  onChange: requestToggle
                }, null, 8, ["checked"])
              ]),
              _hoisted_3
            ]),
            _createVNode(_component_a_descriptions, {
              column: 1,
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "更新后版本（测试版最新）" }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", _hoisted_4, _toDisplayString(targetLoading.value ? '读取中…' : targetVersion.value ? 'V'+targetVersion.value : '暂未获取，请重新打开重试'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "正式版当前版本" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(version.value), 1)
                  ]),
                  _: 1
                }),
                (completed.value && completedTime.value)
                  ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                      key: 0,
                      label: "完成时间"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(completedTime.value), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (enabled.value || completed.value)
                  ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                      key: 1,
                      label: "开启时版本"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(baseline.value), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (completed.value)
              ? (_openBlock(), _createBlock(_component_a_descriptions, {
                  key: 0,
                  title: "申请人通知结果",
                  column: 1,
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(notificationChannels, (item) => {
                      return _createVNode(_component_a_descriptions_item, {
                        key: item.key,
                        label: item.label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(notificationText(notificationStatus.value[item.key])), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"])
                    }), 64))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (visible.value)
              ? (_openBlock(), _createBlock(PlatformOperationVerification, {
                  key: 1,
                  "show-code": false,
                  receiverId: receiverId.value,
                  "onUpdate:receiverId": _cache[0] || (_cache[0] = ($event: any) => ((receiverId).value = $event)),
                  disabled: busy.value,
                  onChanged: _cache[1] || (_cache[1] = ($event: any) => {sent.value=false;code.value='';cooldown.value=0})
                }, null, 8, ["receiverId", "disabled"]))
              : _createCommentVNode("", true),
            (verifying.value)
              ? (_openBlock(), _createBlock(_component_a_form, {
                  key: 2,
                  onFinishFailed: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$operationFormFailure($event))),
                  layout: "vertical"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "短信验证码",
                      help: "验证码5分钟内有效"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: code.value,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((code).value = $event)),
                              style: {"width":"calc(100% - 120px)"},
                              placeholder: "请输入6位验证码",
                              maxlength: 6,
                              onPressEnter: confirm
                            }, null, 8, ["value"]),
                            _createVNode(_component_a_button, {
                              style: {"width":"120px"},
                              disabled: busy.value || cooldown.value>0,
                              onClick: sendCode
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(cooldown.value>0 ? `${cooldown.value}秒后重发` : '获取验证码'), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_a_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (verifying.value=false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("取消")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_button, {
                        type: "primary",
                        loading: busy.value,
                        disabled: !sent.value || !/^\d{6}$/.test(code.value),
                        onClick: confirm
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("验证并开启本次更新")
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (enabled.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (status.value==='claimed')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, "执行端已领取。取消不会中断已经开始的部署。"))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_button, {
                    loading: busy.value,
                    onClick: cancel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("取消本次授权")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["visible"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})